import styled,{css} from 'styled-components';
import {Form, Input, Button} from 'global/styles/styles.js';
import StyledLoader from 'StyledLoader.js';
const S = {};

S.CashoutForm = styled(Form)`
    width: 100%;
    padding: 0.83rem;
    margin-top: -24px;
    position: relative;

    & .full-cashout {
        position: relative;
    }
`;

S.Row = styled.div`
    display: flex;
    flex: 1;
    align-items: flex-start;
`;

S.InfoContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    font-size: 1.5rem;
    color: ${({theme:{$accountProfileBetHistoryCashoutHeader}})=> $accountProfileBetHistoryCashoutHeader};

    & .close {
        display: flex;
        width: 1.5rem;
        height: 1.5rem;
        background: url(/images/svg/ic_modal_close.svg) no-repeat;
        background-size: contain;
    }
`;

S.Label = styled.label`
    color: #787d83!important;
    font-size: 0.81rem;
    font-weight: 400;
    margin-bottom: 0;
    width: 50%;
`;

S.InputWrapper = styled.div`
    width: 50%;
`;

S.Input = styled(Input)`
    box-shadow: none;
    border-radius: .42rem;
    border: .08rem solid #e1e1e1;
    color: #000;
    font-size: 0.94rem;
    background-color: #f6f6f6;
    display: block;
    width: 100%;
    height: 34px;
    text-align: right;
    &:disabled {
        border: none;
        background-color: #fff;
    }
`;

S.SubmitBtn = styled(Button)`
    border-radius: .42rem;
    background-color: #00a651;
    height: 2.13rem;
    line-height: 1;
    font-size: 0.88rem;
    font-weight: 600;
    padding: 0.42rem;
    width: 100px;
    color: #fff;
    min-width: 20%;
    cursor: pointer;
    
    ${({disabled})=> {
        return (disabled == true) && `
                background: #eee;
                opacity: 1;
                color: #676767
        `;
    }}
`;

S.Error = styled.div`
    left: 0;
    color: red;
    margin: 2px 0 0;
    position: absolute;
    font-size: 0.81rem;
`;

S.SubmissionError = styled.div`
    margin: 0;
    border-radius: .25rem;
    width: 100%;
    color: red;
    font-size: 1rem;
    text-align: left;
    padding: .83rem;
    background-color: #fba59f;
`;

S.Stake = styled.div`
    font-weight: 600;
    color: #000;
    font-size: 0.94rem;
    text-align: right;
`;

S.PossibleReturn = styled(S.Stake)``;

S.Button = styled(Button)`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #00a651;
    border-radius: .33rem;
    border: 0;
    color: #fff;
    font-size: 0.88rem;
    cursor: pointer;
    padding: 0.42rem;
    width: 44%;
`;

S.ConclusionMsg = styled.div`
    width: 100%;
    text-align: center;
    border-radius: 4px;
    padding: 10px;
    margin: 10px 0;
    position: relative;
    font-weight: 700;
    border: none;
    color: #000;
    font-size: 2.3332rem;
`;

S.Overlay = styled.div`
    position: absolute;
    left: 0;
    top: -1px;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
    display: flex;
     z-index: 1;
     & ${StyledLoader.LoaderWrapper}{
        position: absolute;
    }
`;

S.TaxInfoMessage = styled.div`
    color: #787d83;
    width: 100%;
    text-align: center;
`; 

S.AcceptCheckbox = styled.div`
    width: 75%;
    margin: 2rem auto;
    label {
        margin-left: 10px;
        font-weight: 600;
        text-align: center;
    }
`;

export default S;